var _path, _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1080 540C1080 838.234 838.234 1080 540 1080C241.766 1080 0 838.234 0 540C0 241.766 241.766 0 540 0C838.234 0 1080 241.766 1080 540ZM540 1050.41C821.892 1050.41 1050.41 821.892 1050.41 540C1050.41 258.108 821.892 29.589 540 29.589C258.108 29.589 29.589 258.108 29.589 540C29.589 821.892 258.108 1050.41 540 1050.41Z",
    fill: "url(#paint0_linear_28_125)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 29,
    width: 1020,
    height: 1020
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 541,
    cy: 539,
    r: 510,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_125)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 541,
    cy: 539,
    r: 540.824,
    fill: "#00013A",
    stroke: "url(#paint1_linear_28_125)",
    strokeWidth: 61.6484
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_28_125)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_28_125)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 733.018,
    cy: 1358.61,
    rx: 993.649,
    ry: 507.501,
    transform: "rotate(-6.48121 733.018 1358.61)",
    fill: "#783DFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_28_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1427.81 936.232C1561.01 848.432 1599.76 758.379 1695.91 633.491C1881.52 392.416 1883.85 190.314 2083.77 -39.7105C2491.68 -509.061 2222.72 1340.08 1595.83 1466.54C1201.75 1546.04 242.744 1248.51 616.218 1107.81C765.371 1051.62 870.102 1101.67 1027.26 1069.04C1189.46 1035.35 1291.89 1025.83 1427.81 936.232Z",
    fill: "url(#paint2_linear_28_125)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_28_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-603.529 1076.3C-910.327 1087.12 -1109.62 1162.19 -1302.02 1339.39C-1691.78 1698.39 616.474 1835.36 289.7 1433.85C83.6632 1180.69 -211.651 1062.48 -603.529 1076.3Z",
    fill: "#006FFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_28_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-379.764 1113.3C-577.502 1126.31 -706.559 1199.3 -832.089 1369.12C-1086.39 1713.15 399.383 1822.43 192.464 1444.48C61.9973 1206.17 -127.189 1096.68 -379.764 1113.3Z",
    fill: "#00FFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_28_125)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_28_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-599.617 1501.42C-301.428 1574.39 -121.561 1688.41 30.7895 1901.03C339.423 2331.77 -1948.47 1996.57 -1546.89 1669.89C-1293.68 1463.91 -980.5 1408.21 -599.617 1501.42Z",
    fill: "#006FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-826.233 1492.15C-635.27 1545.09 -523.749 1642.79 -435.369 1834.59C-256.328 2223.14 -1733.28 2028.06 -1453.84 1700.07C-1277.65 1493.27 -1070.15 1424.52 -826.233 1492.15Z",
    fill: "#00FFFF"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.569 540.415C120.566 579.092 132.033 616.9 153.519 649.059C175.005 681.219 205.545 706.284 241.277 721.085C277.01 735.886 316.328 739.758 354.262 732.212C392.195 724.666 427.038 706.04 454.385 678.691L455.432 677.294L664.941 441.248C677.81 428.351 693.106 418.131 709.948 411.178C726.789 404.226 744.841 400.679 763.06 400.743C800.103 400.743 835.63 415.459 861.823 441.652C888.017 467.846 902.732 503.372 902.732 540.415C902.732 577.459 888.017 612.985 861.823 639.178C835.63 665.372 800.103 680.087 763.06 680.087C744.841 680.151 726.789 676.605 709.948 669.652C693.106 662.7 677.81 652.48 664.941 639.582L635.26 606.061C630.352 600.505 623.437 597.126 616.038 596.667C608.638 596.209 601.359 598.709 595.803 603.617C590.246 608.525 586.867 615.44 586.409 622.839C585.95 630.239 588.45 637.518 593.359 643.074L623.737 677.294L624.785 678.691C642.943 696.85 664.5 711.256 688.225 721.084C711.951 730.912 737.38 735.97 763.06 735.97C788.741 735.97 814.17 730.912 837.895 721.084C861.62 711.256 883.178 696.85 901.335 678.691C928.685 651.344 947.311 616.5 954.857 578.567C962.403 540.634 958.531 501.315 943.73 465.583C928.929 429.851 903.863 399.311 871.704 377.825C839.545 356.338 801.737 344.872 763.06 344.874C737.367 344.777 711.91 349.789 688.171 359.62C664.433 369.451 642.886 383.905 624.785 402.14L623.737 403.537L414.229 639.582C401.36 652.48 386.063 662.7 369.222 669.652C352.381 676.605 334.329 680.151 316.11 680.087C279.066 680.087 243.54 665.372 217.346 639.178C191.153 612.985 176.438 577.459 176.438 540.415C176.438 503.372 191.153 467.846 217.346 441.652C243.54 415.459 279.066 400.743 316.11 400.743C334.329 400.679 352.381 404.226 369.222 411.178C386.063 418.131 401.36 428.351 414.229 441.248L443.91 474.769C448.818 480.326 455.732 483.705 463.132 484.163C470.532 484.622 477.81 482.122 483.367 477.214C488.923 472.305 492.302 465.391 492.761 457.991C493.219 450.592 490.719 443.313 485.811 437.756L455.432 403.537L454.385 402.14C427.038 374.79 392.195 356.165 354.262 348.618C316.328 341.072 277.01 344.945 241.277 359.746C205.545 374.547 175.005 399.612 153.519 431.771C132.033 463.93 120.566 501.739 120.569 540.415Z",
    fill: "url(#paint3_angular_28_125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.121 590.221V579.148H279.511V568.075H290.584V512.71H279.511V501.637H296.121V490.564H307.194V501.637H318.267V490.564H329.34V502.329C334.139 503.621 338.106 506.226 341.244 510.146C344.381 514.07 345.95 518.615 345.95 523.783C345.95 526.459 345.488 529.019 344.566 531.462C343.643 533.909 342.351 536.102 340.69 538.04C343.92 539.977 346.526 542.607 348.508 545.929C350.493 549.251 351.486 552.942 351.486 557.002C351.486 563.092 349.318 568.306 344.981 572.643C340.644 576.98 335.43 579.148 329.34 579.148V590.221H318.267V579.148H307.194V590.221H296.121ZM301.657 534.856H323.804C326.849 534.856 329.456 533.771 331.627 531.601C333.793 529.434 334.877 526.828 334.877 523.783C334.877 520.738 333.793 518.13 331.627 515.96C329.456 513.793 326.849 512.71 323.804 512.71H301.657V534.856ZM301.657 568.075H329.34C332.385 568.075 334.993 566.992 337.163 564.825C339.33 562.655 340.413 560.047 340.413 557.002C340.413 553.957 339.33 551.349 337.163 549.179C334.993 547.012 332.385 545.929 329.34 545.929H301.657V568.075Z",
    fill: "#E3316E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.119 590.221V579.148H731.51V568.075H742.583V512.71H731.51V501.637H748.119V490.564H759.193V501.637H770.266V490.564H781.339V502.329C786.137 503.621 790.105 506.226 793.242 510.146C796.38 514.07 797.948 518.615 797.948 523.783C797.948 526.459 797.487 529.019 796.564 531.462C795.641 533.909 794.35 536.102 792.689 538.04C795.918 539.977 798.524 542.607 800.506 545.929C802.492 549.251 803.485 552.942 803.485 557.002C803.485 563.092 801.316 568.306 796.979 572.643C792.643 576.98 787.429 579.148 781.339 579.148V590.221H770.266V579.148H759.193V590.221H748.119ZM753.656 534.856H775.802C778.847 534.856 781.455 533.771 783.625 531.601C785.792 529.434 786.875 526.828 786.875 523.783C786.875 520.738 785.792 518.13 783.625 515.96C781.455 513.793 778.847 512.71 775.802 512.71H753.656V534.856ZM753.656 568.075H781.339C784.384 568.075 786.992 566.992 789.162 564.825C791.328 562.655 792.412 560.047 792.412 557.002C792.412 553.957 791.328 551.349 789.162 549.179C786.992 547.012 784.384 545.929 781.339 545.929H753.656V568.075Z",
    fill: "#29ABE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_28_125",
    x: -1776.42,
    y: -933.328,
    width: 5042.9,
    height: 3238.54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 214.956,
    result: "effect1_foregroundBlur_28_125"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_28_125",
    x: -690.976,
    y: 406.916,
    width: 2847.99,
    height: 1903.39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 217.502,
    result: "effect1_foregroundBlur_28_125"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_28_125",
    x: 168.995,
    y: -478.345,
    width: 2471.46,
    height: 2320.67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 181.252,
    result: "effect1_foregroundBlur_28_125"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_28_125",
    x: -1781.51,
    y: 640.209,
    width: 2538.02,
    height: 1473.07,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 217.502,
    result: "effect1_foregroundBlur_28_125"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_28_125",
    x: -1151.47,
    y: 821.653,
    width: 1653.78,
    height: 1150.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 145.002,
    result: "effect1_foregroundBlur_28_125"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_28_125",
    x: -3682.93,
    y: -889.778,
    width: 4172.37,
    height: 3424.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 214.956,
    result: "effect1_foregroundBlur_28_125"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_28_125",
    x: -2029.35,
    y: 1022.69,
    width: 2523.88,
    height: 1517.51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 217.502,
    result: "effect1_foregroundBlur_28_125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_125",
    x1: 157.192,
    y1: 121.747,
    x2: 1007.88,
    y2: 1050.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD478F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422577,
    stopColor: "#7230FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#009BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_125",
    x1: 158.5,
    y1: 121.083,
    x2: 1008.5,
    y2: 1049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD478F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422577,
    stopColor: "#7230FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#009BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_125",
    x1: 1813.2,
    y1: 428.212,
    x2: 1181.97,
    y2: 1226.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#994C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD609B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_28_125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(459.786 540.414) rotate(27.3499) scale(130.293 273.893)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114066,
    stopColor: "#29ABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172608,
    stopColor: "#29ABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283514,
    stopColor: "#EE2A67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528748,
    stopColor: "#522785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638338,
    stopColor: "#D71F7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923948,
    stopColor: "#F9A137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9928,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 893.901,
    height: 893.901,
    fill: "white",
    transform: "translate(92.6484 93.4506)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ddb240813f7727100dee0a4b1f5a3b2b.svg";
export { ForwardRef as ReactComponent };